var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94745 4.07931L3.78995 10.5968C3.55745 10.8443 3.33245 11.3318 3.28745 11.6693L3.00995 14.0993C2.91245 14.9768 3.54245 15.5768 4.41245 15.4268L6.82745 15.0143C7.16495 14.9543 7.63745 14.7068 7.86995 14.4518L14.0275 7.93431C15.0925 6.80931 15.5725 5.52681 13.915 3.95931C12.265 2.40681 11.0125 2.95431 9.94745 4.07931Z",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9209 5.16602C9.2434 7.23602 10.9234 8.81851 13.0084 9.02851",
    stroke: "#0A49A5",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.dba4938ed580f5590e5a6ef1ae0b7ecb.svg";
export { ForwardRef as ReactComponent };